import React, { useState } from "react";
import { Row, Col, Button, Modal, Form, Upload, Input, Tag } from 'antd';
import { useTranslation } from "react-i18next";
import useUrlQueryParams from "../../hooks/useUrlQeryParams";
import useGetAllData from "../../hooks/useGetAllData";
import { UploadOutlined } from "@ant-design/icons";
import ViewApplication from "./view";
import CustomPagination from "../../components/pagination";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { submitData } from "./request";
import { Notification } from "../../utils/notification";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import { FILE_URL } from "../../config/utils";
import "./style.css";
import { GrFormView } from "react-icons/gr";

const MyApplication: React.FC = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient();
  const totalItems = localStorage?.getItem('totalItems')
  const [isCreate, setIsCreate] = useState<boolean>(false)

  const [_id, set_id] = useState<number | undefined>()
  const [isOpen, setisOpen] = useState<boolean>(false)

  const { urlValue, writeToUrl } = useUrlQueryParams({
    currentPage: 1,
    perPage: 10,
  });

  const { data: arbitrators } = useGetAllData<any>({
    queryKey: ["online_application_users", urlValue.perPage, urlValue.currentPage],
    url: "online_application_users",
    urlParams: { "PerPage": urlValue.perPage, page: urlValue.currentPage },
  });

  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<
    Array<{ name: string; image: string | ArrayBuffer | null }>
  >([]);

  const beforeUpload = (file: File) => {
    const isAllowed =
      file.type === "application/pdf" ||
      file.type === "application/msword" ||
      file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      file.type === "application/vnd.ms-excel" ||
      file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/zip";

    if (!isAllowed) {
      console.error("Only PDF, Word, Excel, and ZIP files are allowed!");
      return Upload.LIST_IGNORE;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setFileList((prev) => {
        const updatedFiles = [...prev, { name: file.name, image: reader.result }];
        form.setFieldsValue({ files: updatedFiles });
        return updatedFiles;
      });
    };

    return false;
  };

  const { mutate } = useMutation({
    mutationFn: (newVals) => submitData(undefined, newVals),
    onSuccess: async (res) => {
      queryClient.setQueryData(["feedback"], res);
      Notification("success", _id ? "update" : "create", res?.message)
      setIsCreate(false)
      form.resetFields()
    },
    onError: (error: AxiosError) => {
      Notification(`error`, _id ? "update" : "create", error?.name)
    },
    retry: 0,
  });

  const onSubmitJobApplication = (values: any) => {
    mutate({...values, status:0})
  };

  const onCancel = () => {
    setIsCreate(false)
    form.resetFields()
  }
  

  return (
    <div className="py-5">
      <div className="flex justify-between items-center">
        <span></span>
        {/* <Link key={'/send-application'} to={'/send-application'} className="bg-main_color text-white rounded-lg py-2 px-5">{t('Add Application')}</Link> */}
        <Button onClick={() => setIsCreate(true)} className="bg-main_color text-white rounded-lg px-5">{t('Add Application')}</Button>
      </div>

      <Modal title={t("Send application")} centered open={isCreate} footer onCancel={onCancel}>
        <Form form={form} onFinish={onSubmitJobApplication} layout="vertical" className="mt-3">
          <Row>
            <Col span={24}>
              <Form.Item name="title" label={t('Application title')}>
                <Input placeholder={`${t("Input application title ...")}`} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="description" label={t('Description')}>
                <Input.TextArea rows={5} placeholder={`${t("Input description ...")}`} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="files" label={t('Upload file')} required>
                <Upload beforeUpload={beforeUpload} multiple showUploadList>
                  <Button icon={<UploadOutlined />} className="w-full">{t('Upload file')}</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="phone" label={t('Phone number')}>
                <Input placeholder={`${t("Input phone number ...")}`} />
              </Form.Item>
            </Col>
          </Row>
          <Button htmlType="submit" className="w-full bg-green-500 text-white">{t("Send application")}</Button>
        </Form>
      </Modal>

      <div className="scroll-mx-8 overflow-x-auto custom-table">
        <div className="bg-main_color text-white rounded-t-lg px-2 py-3 mt-5 min-w-[1050px]">
          <Row gutter={[24, 24]} className="px-5">
            <Col span={4}>{t('Application title')}</Col>
            <Col span={4}>{t('Description')}</Col>
            <Col span={4}>{t('Phone number')}</Col>
            <Col span={4}>{t('Sended date')}</Col>
            <Col span={4}>{t('File')}</Col>
            <Col span={4}>{t('Status')}</Col>
            {/* <Col span={2}>{t('Action')}</Col> */}
          </Row>
        </div>
        <div className="rounded-b-lg bg-[#E8E8E8] py-3 px-2 border border-solid border-[#B4B4B4] mb-6 min-w-[1050px]">
          {
            arbitrators?.map((item: any) => (
              <div className="bg-white w-full rounded-lg mb-3 hover:bg-[#f5f5f5]">
                <Row gutter={[24, 24]} className="px-5 py-2">
                  <Col span={4}>{item?.title}</Col>
                  <Col span={4}>{item?.description}</Col>
                  <Col span={4}>{item?.phone}</Col>
                  <Col span={4}>{dayjs(item?.createdAt).format('DD-MM-YYYY')}</Col>
                  <Col span={4}>{item?.files?.map((file:any) => <a key={file?.contentUrl} target="_blank" className="text-blue-500 block mb-1" href={`${FILE_URL}${file?.contentUrl}`}>{file?.name}</a>)}</Col>
                  <Col span={4}><Tag color="success">{t('Process')}</Tag></Col>
                  {/* <Col span={2}><GrFormView size={26} color="#4EF068" className="hover:cursor-pointer" onClick={() => {setisOpen(true); set_id(item?.id)}}/></Col> */}
                </Row>
              </div>
            ))
          }
        </div>
      </div>

      <ViewApplication isOpen={isOpen} setisOpen={setisOpen} id={_id} />

      <div className="flex items-center justify-end">
        <CustomPagination
          totalCount={Number(totalItems)}
          currentPage={urlValue.currentPage}
          perPage={urlValue.perPage}
        />
      </div>
    </div>
  )
}

export default MyApplication
